import { render } from "./PhoneNumberInput.vue?vue&type=template&id=ad73fd14&scoped=true"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js"

import "./PhoneNumberInput.vue?vue&type=style&index=0&id=ad73fd14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ad73fd14"

export default script